/**
 * Aligné sur RdvAudioClientSlugger (API) : accents → ASCII, non-alphanum → -, trim.
 */
export function slugifyClientName(name) {
  if (!name || typeof name !== 'string') {
    return '';
  }

  let normalized = name;
  try {
    normalized = name.normalize('NFD');
  } catch {
    normalized = name;
  }

  const withoutMarks = normalized.replace(/\p{Mn}/gu, '');
  const slug = withoutMarks
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  return slug;
}

/**
 * @param {string} label
 * @param {Array<{ slug: string }>} clients
 * @returns {{ slug: string }|null}
 */
export function matchRagClient(label, clients) {
  const needle = slugifyClientName(label);
  if (!needle || !Array.isArray(clients) || clients.length === 0) {
    return null;
  }

  const exact = clients.find((client) => client.slug === needle);
  if (exact) {
    return exact;
  }

  const partial = clients.filter((client) => {
    const slug = String(client.slug || '');
    return slug.includes(needle) || needle.includes(slug);
  });

  if (partial.length === 1) {
    return partial[0];
  }

  return null;
}

/**
 * Tente d'associer un client à partir d'un nom de fichier
 * (après retrait des dates connues).
 *
 * @param {string} filename
 * @param {Array<{ slug?: string, nom?: string, name?: string, folder_id?: string }>} clients
 * @returns {object|null}
 */
export function matchClientFromFilename(filename, clients) {
  if (!Array.isArray(clients) || clients.length === 0) {
    return null;
  }

  const base = String(filename || '').replace(/\.[^.]+$/, '');
  const withoutDates = base
    .replace(/(?<!\d)\d{4}-\d{2}-\d{2}(?!\d)/g, ' ')
    .replace(/(?<!\d)\d{4}\d{2}\d{2}(?!\d)/g, ' ')
    .replace(/(?<!\d)\d{2}[-_.]\d{2}[-_.]\d{4}(?!\d)/g, ' ')
    .replace(/(?<!\d)\d{4}-\d{2}(?!\d)/g, ' ')
    .replace(/[_]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  if (!withoutDates) {
    return null;
  }

  const byLabel = matchRagClient(withoutDates, clients);
  if (byLabel) {
    return byLabel;
  }

  const haystack = slugifyClientName(withoutDates);
  if (!haystack) {
    return null;
  }

  const hits = clients.filter((client) => {
    const slug = String(client.slug || '');
    const nomSlug = slugifyClientName(client.nom || client.name || '');
    if (slug.length >= 3 && haystack.includes(slug)) {
      return true;
    }
    if (nomSlug.length >= 3 && haystack.includes(nomSlug)) {
      return true;
    }
    return false;
  });

  return hits.length === 1 ? hits[0] : null;
}
